(function () {
  'use strict';

  /* @ngdoc object
   * @name productes.main
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main', [
      'ui.router',
      'itecAdministracio.productes.main.llista',
      'itecAdministracio.productes.main.submain.dades',
      'itecAdministracio.productes.main.submain.edit',
      'itecAdministracio.productes.main.submain.permisos',
      'itecAdministracio.productes.main.submain.entitats'
    ]);
}());
